import '../../styles/finixForm.css'

import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack
} from '@mui/material'
import { FC, useContext, useState } from 'react'
import { useParams } from 'react-router-dom'

import { PaymentFinixAchUI } from '../../components/Estimates/RepairOrderPayment/PaymentFinixAchUI'
import AddCardForm from '../../components/Finix/AddCardForm'
import { NotificationContext } from '../../providers'
import { PaymentPortalContext } from '../../providers/PaymentPortalProvider/PaymentPortalProvider'
import { useTextToPayPaymentMutation } from '../../redux/api/paymentApi'
import { formatCurrency } from '../../utils'

const FORM_ID = 'ttp-add-payment'

interface Props {
  handleBack?: () => void
}

enum PaymentMethodOption {
  card = 'card',
  ach = 'ach'
}

export const PaymentForm: FC<Props> = ({ handleBack }) => {
  const { apiKey } = useParams()
  const { setNotice, setError } = useContext(NotificationContext)
  const { amount, surchargeAmount } = useContext(PaymentPortalContext)
  const [textToPayPayment] = useTextToPayPaymentMutation()
  const [loading, setLoading] = useState<boolean>(false)
  const [payViaCard, setPayViaCard] = useState<PaymentMethodOption>(
    PaymentMethodOption.card
  )

  const finixFormSubmitCallback = async function (
    err: any,
    res: any,
    useLevelOneProcessing: boolean
  ) {
    try {
      setLoading(true)
      if (err) {
        setError('Error reading payment info')
      } else {
        const result = await textToPayPayment({
          xAPIKey: apiKey!,
          textToPayPaymentRequest: {
            token: res.data.id,
            amountCents: amount,
            surchargeCents: surchargeAmount === 0 ? undefined : surchargeAmount,
            useLevelOneProcessing:
              useLevelOneProcessing === true ? true : undefined
          }
        })
        if ('data' in result) {
          setNotice('Successfully completed payment')
        } else {
          setError('Error completing payment')
        }
        setNotice('Successfully processed payment info')
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Stack spacing={2} alignItems="center">
        <Box>
          To Be Paid: <b>{formatCurrency(amount / 100, true)}</b>
        </Box>
        <Box width={200}>
          <FormControl fullWidth>
            <InputLabel>Payment Method</InputLabel>
            <Select
              label="Payment Method"
              value={payViaCard}
              onChange={(event) =>
                setPayViaCard(event.target.value as PaymentMethodOption)
              }>
              <MenuItem value={PaymentMethodOption.card}>Card</MenuItem>
              {/* <MenuItem value={PaymentMethodOption.ach}>ACH</MenuItem> */}
            </Select>
          </FormControl>
        </Box>
        <Box>
          {payViaCard === PaymentMethodOption.card && (
            <AddCardForm
              formId={FORM_ID}
              submitCallback={finixFormSubmitCallback}
            />
          )}
          {payViaCard === PaymentMethodOption.ach && (
            <PaymentFinixAchUI
              formId={FORM_ID}
              submitCallback={finixFormSubmitCallback}
            />
          )}
        </Box>
        <Stack direction="row" spacing={1}>
          {handleBack && (
            <Button variant="outlined" onClick={handleBack}>
              Back
            </Button>
          )}
          <Button
            type="submit"
            form={FORM_ID}
            variant="contained"
            disabled={loading}>
            {loading ? 'Sending...' : 'Checkout'}
          </Button>
        </Stack>
      </Stack>
    </Paper>
  )
}
